// extracted by mini-css-extract-plugin
module.exports = {"container":"MaintenancePage_container__1pEoE","logo":"MaintenancePage_logo__1oGkD","title":"MaintenancePage_title__1S7c1","subtitle":"MaintenancePage_subtitle__1YLJj"};